module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "locationEmail.fb43bf8c.svg";